import React from "react";

export const CarbonCapture = [
  <div className="slideContainer slide_solidColour">
    <div className="colLeft col50">
      <h4 className="slideTitle">
        Carbon Capture and Storage to help accelerate decarbonization
      </h4>
      <ul className="shell_bullets_list">
        <li>
          We are developing commercial CCS hubs that enable decarbonization of
          multiple customers by capturing some of their unavoidable carbon
          emissions; whilst supporting Shell’s role in the energy transition.
        </li>
        <li>
          Our ambition is to store over 25Mln tonnes CO<sub>2</sub> per annum by 2035.
        </li>
        <li>
          We work with governments to help shape their net-zero emission
          pathways and advocate for CCS through active membership in industrial
          organisations.
        </li>
      </ul>
      <img
        alt=""
        class=""
        src="images/CCSaccelerate.JPG"
        width="85%"
        height="auto"
      />
    </div>
    <div className="colRight col50 solidColourContainer">
      <p>More widely, Shell is working on CCS opportunities that enable:</p>
      <img
        alt=""
        class=" mb-4"
        src="images/CCSgrid.JPG"
        width="100%"
        height="auto"
      />
      <p>
        Northern Lights is the first CCS project of its kind that allows the
        transport of CO<sub>2</sub> from industrial sites to be permanently
        stored below ground.
      </p>
      <p>
        This collaboration between Shell, Equinor and Total – was given its
        final funding decision by the Norwegian government on December 15, 2020.
      </p>
    </div>
  </div>,
  <>
    <h4 className="slideTitle">
      CCS is essential for deep decarbonization of industry
    </h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/CCSessential.JPG" width="100%" height="auto" />
    </div>
  </>,
  <>
    <h4 className="slideTitle">CCS is based on proved technologies</h4>
    <div className="slideContainer slide_solidColour">
      <img src="images/CCSProof.JPG" width="100%" height="auto" />
    </div>
  </>,
];
